export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*.,?"'()+-/:;<=>[\]\\_`{|}~]).{6,}$/;
export const PASSWORD_MIN_LENGTH = 6;
export const PATIENT_CONSUMER_PROFESSION_ID = 42;
